<template>
	<v-tab-item>
		<v-card flat>
			<h3 class="text-h6 font-weight-bold">依頼</h3>
			<v-sheet elevation="0">
				<!-- TODO authorityによる表示 -->
				<ConfirmationSection
					:name="'依頼'"
					:actionName="'承認'"
					:requiredConfirmationDialog="false"
					@accept="confirmationDialog = true"
					@reject="rejectRequirement($event)"
				/>

				<table width="100%" class="show-dialog-table">
					<tbody>
						<tr>
							<th width="30%" class="font-weight-bold">依頼名</th>
							<td width="70%" class="no-wrap">
								{{ requirement.requirement_type.name }}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">
								サブタイトル
								<v-icon class="float-right" v-if="fixed('subtitle')">mdi-clock-edit-outline</v-icon>
							</th>
							<td width="70%" class="no-wrap">
								{{ requirement.subtitle }}
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openRequirementEditDialog('サブタイトル', 'text', 'subtitle')"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">状態</th>
							<td width="70%" class="no-wrap">
								{{ requirement.status_id_i18n }}
								<v-icon
									v-if="
										requirementAuthorityFlag &&
										(requirement.status_id == 'draft' || requirement.status_id == 'refused')
									"
									class="float-right"
									@click="openConfirm()"
								>
									mdi-send
								</v-icon>
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼発行日</th>
							<td width="70%" class="no-wrap">
								{{
									requirement.requirement_date
										? common.tranceMoment(requirement.requirement_date)
										: ""
								}}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">
								希望納期
								<v-icon class="float-right" v-if="fixed('deadline')">mdi-clock-edit-outline</v-icon>
							</th>
							<td width="70%" class="no-wrap">
								{{ common.formatDate(requirement.deadline) }}
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openRequirementEditDialog('希望納期', 'date', 'deadline')"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼元部門</th>
							<td width="70%" class="no-wrap">
								{{
									$store.getters.department(requirement.from_department_id)
										? $store.getters.department(requirement.from_department_id).name
										: ""
								}}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼者</th>
							<td width="70%" class="no-wrap">
								{{ requirement.user ? requirement.user.full_name : "" }}
							</td>
						</tr>
						<tr v-if="requirement.requirement_type.confirmation_flag">
							<th width="30%" class="font-weight-bold">確認者</th>
							<td width="70%" class="no-wrap" v-if="requirement.confirmations">
								<p
									class="no-wrap"
									v-for="confirmation in requirement.confirmations"
									:key="'confirmation-' + confirmation.id"
								>
									{{ confirmation.user.full_name }}
									<span class="fs0875">{{ common.formatDate(confirmation.created_at) }}</span>
								</p>
							</td>
							<td width="70%" class="no-wrap" v-else></td>
						</tr>
						<tr v-if="requirement.requirement_type.approval_flag">
							<th width="30%" class="font-weight-bold">承認者</th>
							<td width="70%" class="no-wrap" v-if="requirement.approvals">
								<p
									class="no-wrap"
									v-for="approval in requirement.approvals"
									:key="'approval-' + approval.id"
								>
									{{ approval.user.full_name }}
									<span class="fs0875">{{ common.formatDate(approval.created_at) }}</span>
								</p>
							</td>
							<td width="70%" class="no-wrap" v-else></td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">依頼先部門</th>
							<td width="70%" class="no-wrap">
								{{
									$store.getters.department(requirement.to_department_id)
										? $store.getters.department(requirement.to_department_id).name
										: ""
								}}
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">担当者</th>
							<td width="70%" class="no-wrap">
								{{ requirement.responder != null ? requirement.responder.full_name : "未定" }}
							</td>
						</tr>
						<tr v-if="requirement.requirement_type.need_matter_flag">
							<th width="30%" class="font-weight-bold">
								案件
								<v-icon class="float-right" v-if="fixed('matter_id')"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap">
								<p v-text="common.returnMatterInfo(requirement.matter)" />
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openRequirementEditDialog('案件', 'matter', 'matter_id')"
								>
									mdi-pencil-box
								</v-icon>
							</td>
						</tr>
						<tr
							v-if="requirement.requirement_type.need_matter_flag && !requirement.matter.contract"
						>
							<th width="30%" class="font-weight-bold">
								見積製品（対象絞り込み）
								<v-icon class="float-right" v-if="fixed('matter_product_id')"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap">
								<p v-text="common.matterProductByRequirement(requirement)" />
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="
										openRequirementEditDialog('見積製品', 'matter_product', 'matter_product_id')
									"
								>
									mdi-pencil-box
								</v-icon>
							</td>
						</tr>
						<tr v-if="requirement.requirement_type.need_matter_flag && requirement.matter.contract">
							<th width="30%" class="font-weight-bold">
								受注製品(製番)
								<v-icon class="float-right" v-if="fixed('ordered_product_id')"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap">
								<p v-text="common.orderedProductByRequirement(requirement)" />
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="
										openRequirementEditDialog('受注製品', 'ordered_product', 'ordered_product_id')
									"
								>
									mdi-pencil-box
								</v-icon>
							</td>
						</tr>

						<tr v-if="requirement.requirement_type.need_matter_flag">
							<th width="30%" class="font-weight-bold">
								<template v-if="requirement.matter.contract"> 受注製品(枝番) </template>
								<template v-else> 見積製品(枝番) </template>
								<v-icon class="float-right" v-if="fixed('order_individual_info_id')"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap">
								<p v-text="common.orderIndividualInfoByRequirement(requirement)" />
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="
										openRequirementEditDialog(
											'受注製品(枝番)',
											'ordered_product',
											'order_individual_info_id'
										)
									"
								>
									mdi-pencil-box
								</v-icon>
							</td>
						</tr>

						<tr v-for="column in requirement.requirement_type.requirement_columns" :key="column.id">
							<th width="30%" class="font-weight-bold">
								{{ column.name }}
								<v-icon class="float-right" v-if="valueFixed(valueByColumn(column))"
									>mdi-clock-edit-outline</v-icon
								>
							</th>
							<td width="70%" class="no-wrap" v-if="column.data_type == 'file'">
								<v-btn
									color="transparent"
									class="no-shadow no-border pa-1"
									@click="openFilesDialog(valueByColumn(column))"
								>
									<v-icon>mdi-folder-outline</v-icon>
									{{
										checkFileExist(lodashGet(valueByColumn(column), "attached_files"))
											? "内容を確認する"
											: "アップロードする"
									}}
								</v-btn>
								<p
									class="no-wrap"
									style="font-size: 0.875rem"
									v-if="!checkFileExist(lodashGet(valueByColumn(column), 'attached_files'))"
								>
									添付ファイルはありません
								</p>
							</td>

							<td width="70%" class="no-wrap" v-else-if="column.data_type == 'text'">
								<div class="pre-wrap" v-text="value(column)"></div>
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>

							<td width="70%" class="no-wrap" v-else-if="column.data_type != 'synchronization'">
								{{ value(column) }}
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>
							<td width="70%" class="no-wrap" v-else-if="column.data_type == 'synchronization'">
								<RubberProcessShowDialog
									v-if="column.data_synchronization.reflect_model == 'RubberProcess'"
									:id="synchronizationModelId(column)"
									:is_draft="!!valueByColumn(column).value.synchronized_datum"
									:showEditBtn="false"
									requiredDialogBtn
								>
									<template v-slot:open-btn="{ openDialog }">
										<a @click="openDialog">
											{{ value(column) }}
										</a>
									</template>
								</RubberProcessShowDialog>
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openValueEditDialog(valueByColumn(column), column)"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
						<tr>
							<th width="30%" class="font-weight-bold">
								伝達事項
								<v-icon class="float-right" v-if="fixed('message')">mdi-clock-edit-outline</v-icon>
							</th>
							<td width="70%" class="no-wrap">
								<div class="pre-wrap">{{ requirement.message }}</div>
								<v-icon
									v-if="requirementAuthorityFlag"
									class="float-right"
									@click="openRequirementEditDialog('伝達事項', 'text', 'message')"
									>mdi-pencil-box</v-icon
								>
							</td>
						</tr>
						<tr v-if="requirement.previous_requirement">
							<th width="30%" class="font-weight-bold">前の依頼</th>
							<td width="70%" class="no-wrap">
								<a @click="$emit('reload-requirement', requirement.previous_requirement.id)">
									{{ requirement.previous_requirement.requirement_type.name }}
								</a>
							</td>
						</tr>
						<tr v-if="requirement.next_requirement">
							<th width="30%" class="font-weight-bold">次の依頼</th>
							<td width="70%" class="no-wrap">
								<a @click="$emit('reload-requirement', requirement.next_requirement.id)">
									{{ requirement.next_requirement.requirement_type.name }}
								</a>
							</td>
						</tr>
					</tbody>
				</table>
			</v-sheet>
		</v-card>
		<FilesDialog ref="files" @set-files="setFiles" />
		<RequirementSmallEditDialog ref="edit" @update-requirement="updateRequirement($event)" />
		<RequirementValueSmallEditDialog
			ref="editValue"
			@update-requirement-values="updateRequirementValues($event)"
		/>
		<ChangeStatusFromDraft ref="changeFromDraft" @reloadShow="reloadShow" />
		<DeleteConfirm ref="deleteConfirm" @chose="deleteRequirement()" />
		<!-- TODO -->
		<RequirementConfirm
			ref="deleteConfirm"
			:confirmPackage="{}"
			:approvalFlag="true"
			:confirmationFlag="false"
			@approveRequirement="approveRequirement"
			@confirmRequirement="confirmRequirement"
		/>
	</v-tab-item>
</template>

<script>
import axios from "axios"
import lodashGet from "lodash/get" // templateのオプショナルチェーン用
import errorHandling from "../../../../helper/errorHandling"
import authenticate from "../../../../helper/authenticate"
import common from "../../../../helper/common"
import FilesDialog from "../RequirementValueFilesDialog.vue"
import ChangeStatusFromDraft from "../ChangeStatusFromDraft.vue"
import RequirementSmallEditDialog from "../RequirementSmallEditDialog.vue"
import RequirementValueSmallEditDialog from "../RequirementValueSmallEditDialog.vue"
import ConfirmationSection from "../../../shared/ConfirmationSection.vue"
import RequirementConfirm from "../RequirementConfirm.vue"
import DeleteConfirm from "../DeleteConfirm.vue"

export default {
	props: {
		requirement_data: {
			type: Object,
			required: true,
		},
		requirementAuthorityFlag: {
			type: Boolean,
			required: false,
			default: false,
		},
		isFetched: {
			type: Boolean,
		},
	},
	components: {
		FilesDialog,
		ChangeStatusFromDraft,
		RequirementSmallEditDialog,
		RequirementValueSmallEditDialog,
		ConfirmationSection,
		RequirementConfirm,
		DeleteConfirm,
		RubberProcessShowDialog: () =>
			import("../../../rubber_process/components/RubberProcessShowDialog.vue"),
	},
	data() {
		return {
			confirmationDialog: false,
			common,
			lodashGet,
		}
	},
	methods: {
		openDeleteConfirm() {
			this.$refs.deleteConfirm.openDialog(
				"本当に削除しますか?",
				"添付データなど全てのデータが削除されます"
			)
		},

		updateRequirement(requirement) {
			requirement.changed_column.forEach((c) => {
				if (c == "matter_id") {
					this.requirement[c] = requirement.data[c]
					this.requirement.matter = requirement.data.matter
				} else if (c == "matter_product_id") {
					this.requirement[c] = requirement.data[c]
					this.requirement.matter_product = requirement.data.matter_product
				} else if (c == "ordered_product_id") {
					this.requirement[c] = requirement.data[c]
					this.requirement.ordered_product = requirement.data.ordered_product
				} else if (c == "order_individual_info_id") {
					this.requirement[c] = requirement.data[c]
					this.requirement.order_individual_info = requirement.data.order_individual_info
				} else {
					this.requirement[c] = requirement.data[c]
				}
			})
			if (requirement.fix) {
				this.requirement.requirement_fixes.push(requirement.fix)
			}
			this.$emit("update-requirement", this.requirement)
		},
		updateRequirementValues(data) {
			let requirementValue = this.requirement.requirement_values.find((v) => v.id == data.value.id)
			if (!requirementValue) return
			const index = this.requirement.requirement_values.indexOf(requirementValue)
			requirementValue.value = data.value.value
			if (data.fix) requirementValue.requirement_value_fixes.push(data.fix)
			this.requirement.requirement_values[index] = requirementValue
			this.$emit("update-requirement-values", this.requirement)
		},
		setFiles(files, id) {
			const value = this.requirement.requirement_values.find((v) => v.id == id)
			if (!value) return
			const index = this.requirement.requirement_values.indexOf(value)
			this.requirement.requirement_values[index].attached_files = files
		},
		editDialog(dataSet) {
			this.$refs.edit.setEditData(dataSet)
		},
		reloadShow(requirement, statusName) {
			this.requirement.requirement_date = requirement.requirement_date
			this.requirement.status_id = requirement.status_id
			this.requirement.status_id_i18n = statusName
			this.$emit("update-requirement", this.requirement)
		},
		openConfirm() {
			this.$refs.changeFromDraft.openDialog(this.requirement.id)
		},
		openFilesDialog(value) {
			this.$refs.files.openDialog(value.id)
		},
		deleteRequirement() {
			const headers = authenticate.setHeader()
			axios
				.delete("/erp/v1/requirements/" + this.requirement.id + ".json", {
					headers,
				})
				.then((response) => {
					this.$store.dispatch("setFlash", {
						text: "削除しました",
						type: "notice",
					})
					this.open = false
					this.$emit("reloadIndex")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		diffDate(deadline) {
			let today = moment(new Date())
			let gap = moment(deadline).diff(today, "days")
			if (gap <= 5) {
				return true
			} else {
				return false
			}
		},
		openValueEditDialog(value, column) {
			let dataSet = {
				value: value,
				requirement: this.requirement,
				column: column,
				user: this.$store.getters["auth/authData"],
			}
			this.$refs.editValue.setEditData(dataSet)
		},
		openRequirementEditDialog(label, dataType, keyword) {
			let dataSet = {
				requirement: this.requirement,
				selectedMatter: this.requirement.matter,
				label: label,
				dataType: dataType,
				dataKey: keyword,
				showIndex: this.showIndex,
				user: this.$store.getters["auth/authData"],
			}
			this.$refs.edit.setEditData(dataSet)
		},
		valueByColumn(column) {
			return this.requirement.requirement_values.find((v) => v.requirement_column_id == column.id)
		},
		value(column) {
			return common.value(column, this.valueByColumn(column)?.value)
		},
		synchronizationModelId(column) {
			let value = this.valueByColumn(column)?.value
			return value?.synchronized_datum?.id || value?.model?.id
		},
		rejectRequirement(reason) {
			// TODO
		},
		approveRequirement() {
			// TODO
		},
		confirmRequirement() {
			// TODO
		},
	},
	computed: {
		requirement: {
			get() {
				return this.requirement_data
			},
			set(newVal) {
				return this.$emit("update:requirement_data", newVal)
			},
		},
		fixed() {
			return (columnName) => {
				return this.requirement.requirement_fixes.find((fix) => fix[columnName] != null) != null
			}
		},
		valueFixed() {
			return (value) => {
				if (value == null) return null
				return value.requirement_value_fixes?.length
			}
		},
		checkFileExist() {
			return (attachedFiles) => {
				if (attachedFiles == null || attachedFiles == []) return false
				return attachedFiles.filter((file) => !file.destroy_flag).length > 0
			}
		},
	},
	watch: {
		deep: true,
	},
}
</script>
